/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * The SKY API
 * OpenAPI spec version: 1.0.0
 */

export type UserStatus = typeof UserStatus[keyof typeof UserStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserStatus = {
  ONFIRMED: 'ONFIRMED',
  FORCE_CHANGE_PASSWORD: 'FORCE_CHANGE_PASSWORD',
} as const;
